import { Component, Input } from '@angular/core';
import { CrActiviteInterne } from '../../../shared/models/activite-interne/activite-interne.model';
import { DatePipe, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cr-activite-interne-item',
  templateUrl: 'cr-activite-interne-item.component.html',
  standalone: true,
  styleUrls: ['./cr-activite-interne-item.component.scss'],
  imports: [DatePipe, TranslateModule, NgIf],
})
export class CrActiviteInterneItemComponent {
  @Input() cr: CrActiviteInterne;
}
